import { z } from 'zod';

import { metadata } from '@nesso/common-contracts/schema-metadata';

export const CLIENT_BILLING_SETTINGS_TYPES = ['superbill', 'fees'] as const;

export const SUPERBILL_SETTINGS_TYPE = 'superbill' as const;

export const SUPERBILL_LOCATIONS = ['DEFAULT_LOCATION', 'SERVICE_LOCATION'] as const;

export const superbillSettingsValueSchema = z.object({
    location: z.enum(SUPERBILL_LOCATIONS).meta(metadata.nonSensitive),
});

export type SuperbillSettingsValue = z.infer<typeof superbillSettingsValueSchema>;

export const superbillSettingsPatchSchema = superbillSettingsValueSchema.partial();

export type SuperbillSettingsPatch = z.infer<typeof superbillSettingsPatchSchema>;

export const FEES_SETTINGS_TYPE = 'fees' as const;

export const MAX_FEE_BASIS_POINTS = 10_000;

export const feesSettingsValueSchema = z.object({
    lateCancelBasisPoints: z
        .number()
        .int()
        .min(0)
        .max(MAX_FEE_BASIS_POINTS)
        .meta(metadata.nonSensitive),
    noShowBasisPoints: z
        .number()
        .int()
        .min(0)
        .max(MAX_FEE_BASIS_POINTS)
        .meta(metadata.nonSensitive),
});

export type FeesSettingsValue = z.infer<typeof feesSettingsValueSchema>;

export const feesSettingsPatchSchema = feesSettingsValueSchema.partial();

export type FeesSettingsPatch = z.infer<typeof feesSettingsPatchSchema>;
